/*
 * @Author: mokinzhao
 * @Date: 2019-09-05 16:56:19
 * @Description:
 * @LastEditTime: 2019-09-05 17:43:46
 */
const BaseUrl = "https://imguki.neoclub.cn/miaohong/offical/cartoon/";
export const banner = BaseUrl + "banner/banner.jpg";
export const ImgList = [
  {
    id: 1,
    views: "2323",
    imgUrl: BaseUrl + "title/1.jpg",
    avatar: BaseUrl + "head/1.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 2,
    views: "3223",
    imgUrl: BaseUrl + "title/2.jpg",
    avatar: BaseUrl + "head/2.jpeg",
    name: "菲拉基米儿"
  },
  {
    id: 3,
    views: "365756",
    imgUrl: BaseUrl + "title/3.jpg",
    avatar: BaseUrl + "head/3.jpeg",
    name: "塞饿的斯"
  },
  {
    id: 4,
    views: "365567",
    imgUrl: BaseUrl + "title/4.jpg",
    avatar: BaseUrl + "head/4.jpeg",
    name: "伊泽瑞尔"
  },
  {
    id: 5,
    views: "2342342",
    imgUrl: BaseUrl + "title/5.jpg",
    avatar: BaseUrl + "head/5.jpeg",
    name: "泰坦"
  },
  {
    id: 6,
    views: "23665",
    imgUrl: BaseUrl + "title/6.jpg",
    avatar: BaseUrl + "head/6.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 7,
    views: "331",
    imgUrl: BaseUrl + "title/7.jpg",
    avatar: BaseUrl + "head/7.jpeg",
    name: "修罗"
  },
  {
    id: 8,
    views: "33133",
    imgUrl: BaseUrl + "title/8.jpg",
    avatar: BaseUrl + "head/8.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 9,
    views: "23245",
    imgUrl: BaseUrl + "title/9.jpg",
    avatar: BaseUrl + "head/9.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 10,
    views: "23245",
    imgUrl: BaseUrl + "title/10.jpg",
    avatar: BaseUrl + "head/10.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 11,
    views: "57876",
    imgUrl: BaseUrl + "title/11.jpg",
    avatar: BaseUrl + "head/11.jpeg",
    name: "风骑士"
  },
  {
    id: 12,
    views: "23245",
    imgUrl: BaseUrl + "title/12.jpg",
    avatar: BaseUrl + "head/12.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 13,
    views: "667323",
    imgUrl: BaseUrl + "title/13.jpg",
    avatar: BaseUrl + "head/13.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 14,
    views: "35633",
    imgUrl: BaseUrl + "title/14.jpg",
    avatar: BaseUrl + "head/14.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 15,
    views: "4534231",
    imgUrl: BaseUrl + "title/15.jpg",
    avatar: BaseUrl + "head/15.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 16,
    views: "234225",
    imgUrl: BaseUrl + "title/16.jpg",
    avatar: BaseUrl + "head/16.jpeg",
    name: "莎娃"
  },
  {
    id: 17,
    views: "12521",
    imgUrl: BaseUrl + "title/17.jpg",
    avatar: BaseUrl + "head/17.jpeg",
    name: "赫尔辛基"
  },
  {
    id: 18,
    views: "567856",
    imgUrl: BaseUrl + "title/18.jpg",
    avatar: BaseUrl + "head/18.jpeg",
    name: "阿尔萨斯"
  },
  {
    id: 19,
    views: "465456",
    imgUrl: BaseUrl + "title/19.jpg",
    avatar: BaseUrl + "head/19.jpeg",
    name: "苏伊士"
  },
  {
    id: 20,
    views: "997723",
    imgUrl: BaseUrl + "title/20.jpg",
    avatar: BaseUrl + "head/20.jpeg",
    name: "伊斯丹"
  }
];
